import React from 'react'

import Flex from 'styled-flex-component'

import { useMobileMenuControls } from '@context/MobileMenuControls'
import Theme from '@theme'
import { Icon, Text } from '@tribegroup'
import { LogoLink } from '../TitleBar'
import TitleBarStyled, {
  HeaderAboveSidebar,
  StyledHeaderTextWrapper,
  StyledMobileMenu,
} from '../TitleBar.styled'

interface ITitleBarMobileProps {
  title: React.ReactNode
  count?: React.ReactNode
}

export const TitleBarMobile: React.FC<ITitleBarMobileProps> = ({ title, count }) => {
  const { toggleMobileMenu } = useMobileMenuControls()

  return (
    <TitleBarStyled mobile>
      <Flex justifyBetween full alignCenter>
        <HeaderAboveSidebar justifyBetween alignCenter>
          <LogoLink />
        </HeaderAboveSidebar>
        <StyledMobileMenu onClick={toggleMobileMenu} justifyCenter alignCenter>
          <Text color={Theme.grey900Color}>{title}</Text>
          <StyledHeaderTextWrapper>
            <Text capitalize color={Theme.grey700Color}>
              {count}
            </Text>
          </StyledHeaderTextWrapper>
          <Icon glyph="chevron-down" size={1.5} color={Theme.grey700Color} />
        </StyledMobileMenu>
      </Flex>
    </TitleBarStyled>
  )
}

export default TitleBarMobile
